import React, { useState } from "react";
import { createContext } from "react";

export const DataContext = createContext();
export default function DataProvider({ children }) {
  const [formData, setFormData] = useState({
    name: "",
    price: Number(0),
    limit: Number(0),
    imgSrc: "",
    slug: "",
    categories: "",
    color: "",
    description: "",
  });

  const [filledState, setFilledState] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <DataContext.Provider
      value={{
        formData,
        setFormData,
        filledState,
        setFilledState,
        isLoading,
        setIsLoading,
      }}
    >
      {children}
    </DataContext.Provider>
  );
}
